import React from "react";
import WhyAreWe from "../../components/About/WhyAreWe";
import image1 from "../../assets/images/resources/why-are-we-img-1.jpg";
import image2 from "../../assets/images/resources/why-are-we-img-2.jpg";

const WhyAreWeSec = () => {
  const points = [
    {
      iconClass: "why-are-we__icon",
      arrowIcon: "icon-arrow-down-left",
      icon: "icon-location why-are-we__location",
      heading: "24/7 Support",
      text: "Prompt, all-weather service anytime you need.",
    },
    {
      iconClass: "why-are-we__icon-2",
      arrowIcon: "icon-arrow-down-right",
      icon: "icon-shopping-cart why-are-we__cart",
      heading: "Expert Maintenance",
      text: "Trained teams with strict quality control systems.",
    },
    {
      iconClass: "",
      arrowIcon: "",
      icon: "icon-call why-are-we__call",
      heading: "Project-Focused Care",
      text: "Dedicated staff for regular checks on large sites.",
    },
  ];
  return (
    <>
      <WhyAreWe
        imageSrc1={image1}
        imageSrc2={image2}
        tagline="Why Choose Arch Elevators?"
        title="Excellence in Every Rise. Trust in Every Floor."
        points={points}
        year="Since 1991"
        yearDescription="Delivering smart vertical mobility through precision planning, seamless execution, and expert maintenance — redefining efficiency in every rise."
      />
    </>
  );
};

export default WhyAreWeSec;
